<script setup>
import {ref, onMounted, watch, computed, getCurrentInstance, toRaw, onBeforeUnmount, inject, defineExpose} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SNB from '../../../../../layouts/nav/SNB.vue'
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import {useUserStore} from "../../../stores/user";
import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import JobFairResumeOpenModal from "../../../components/modal/jobFair/JobFairResumeOpenModal.vue";
import LecturePlayerModal from "../../../components/modal/mypage/LecturePlayerModal.vue";
import LectureResumeModal from "../../../components/modal/mypage/MyPageResumeModal.vue";
import LectureSurveyModal from "../../../components/modal/mypage/LectureSurveyModal.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import KSATextButton from "../../../../../components/ui-components/button/KSATextButton.vue";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import MyPageCorpJobFairCorpInfoView from "../../../views/mypage/corpJobFair/MyPageCorpJobFairCorpInfoView.vue";
import jobFairUserService from "../../../services/jobFair/jobFairUserService";
import JobFairJobNoticeModal from "../../../components/modal/jobFair/JobFairJobNoticeModal.vue";
import JobFairResumeModal from "@/pages/user/components/modal/jobFair/JobFairResumeModal.vue";
import JobFairJobNoticeListModal from "@/pages/user/components/modal/jobFair/JobFairJobNoticeListModal.vue";
import KSAInputGeneralPhoneNum from "@/components/ui-components/input/KSAInputGeneralPhoneNum.vue";
import KSAInputNumber from "@/components/ui-components/input/KSAInputNumber.vue";
import _ from "lodash";
import moment from "moment";
import fileService from "@/services/fileService";
import JobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import KSAInput from "@/components/ui-components/input/KSAInput.vue";
import jobFairGnbService from "@/pages/user/services/jobFair/jobFairGnbService";
import adminCorporationService from "@/pages/admin/services/corporation/adminCorporationService";
import { useAlertStore } from '../../../../../stores/alertStore';
const { $alert, $confirm } = useAlertStore();

const route = useRoute()
const router = useRouter()
const loadingStore = usePageLoadingStore()
const { user, isAuthenticated } = useUserStore()
const { $pageListBoardNo } = getCurrentInstance().appContext.config.globalProperties;

const globals = getCurrentInstance().appContext.config.globalProperties;
const { $regex, $gb : { EMPLOYEE_NUM_GB, SALES_AMT_GB } } = globals;

const JOB_FAIR = 'JOB_FAIR';
const CORP_UPDATE = 'CORP_UPDATE'; // 기업정보 관리 수정
const RECRUITMENT_HALL = 'RECRUITMENT_HALL'; // 참가신청 정보 관리 수정
const RETRIEVE_APPLICANT = 'RETRIEVE_APPLICANT'; // 입사지원 목록

onBeforeUnmount(()=>{
  localStorage.removeItem('data-lect-cert');
})

onMounted( ()=>{

  const { id } = route.params;
  if(!id) {
    router.push({name: 'MyPageCorpOpenRecruitment'})
  } else {
    // loadingStore.loading = true;
    const p1 = ojfDetailByIdAndCorpId(id)
    Promise.all([p1])
      .then( async (res) => {
        loadingStore.loading = false;
        if(res[0].data.code.toLowerCase() === 'success'){
          const result = res[0].data.result;
          jobDetail.value = result;

          ojfIntvDay(jobDetail.value.ojfId); // 면접 가능일 조회
        }
      })
    _.each(intvDays.value, el => {el.on = false;})
  }
})

const viewMode = ref(JOB_FAIR); // JOB_FAIR

const jobDetail = ref({}); // 특별채용관 상세

const jobNoticeList = ref({}); // 채용공고 관리 및 지원 현황
const applicantList = ref({}); // 입사지원 목록
const interestEntryList = ref({}); // 관심 인재
const interviewProposaList = ref({}); // 면접제안 인재

const residenceAreaRef = ref(null);

const intvDays = ref([]); // 면접 가능일
const isAllActive = ref(false); // 면접일 전체
const isEtcActive = ref(false); // 면접일 외 일정

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);

const currentPageDepth2 = ref(1);
const totalPagesDepth2 = ref(1);
const totalCountDepth2 = ref(0);

const detailCommonId = ref('');    // jobNoticeSeq
const detailCommonData = ref('');   // fileYn

const pageSizeGroup = ref([
  { label:"10개씩 보기", value: 10 },
  { label:"30개씩 보기", value: 30 },
  { label:"50개씩 보기", value: 50 },
  { label:"100개씩 보기", value: 100 },
])

const tabOptions = ref([
  {label:'행사정보', value: 0},
  {label:'기업정보 관리', value: 1},
  {label:'참가신청 정보 관리', value: 2},
  {label:'채용공고 관리 및 지원 현황', value: 3},
  {label:'관심인재', value:4},
  {label:'면접제안 인재', value: 5},
]);
const tabIndex = ref(0)

onMounted(() => {

  if (history.state?.tab) {
    tabIndex.value = history.state.tab;
  }

})

let userBizNum = user.userInfo.corporation.bizNum
if (userBizNum) {
  userBizNum = userBizNum.substring(0,3) + '-' + userBizNum.substring(3,5) + '-' + userBizNum.substring(5);
}
// 기업정보 관리 상세
const corpDetail = ref({});
// 기업정보 관리 수정
const corpUpdate = ref({
  ojfId: 0,
  bizNum: '', // 사업자등록번호
  corpName: '', // 기업명
  ceoName: '', // 대표자명
  residenceArea1: '', // 사업장소재지1
  residenceArea2: '', // 사업장소재지2
  bizType: '', // 업종
  industryGb: '', // 산업구분
  industryText: '', // 사업구분 기타
  corpGb: '', // 기업형태
  corpText: '', // 기업형태 기타
  foundYm: '', // 창립연월
  employeeNumGb: '', // 사원수(인원구분)
  salesAmtGb: "00", // 매출액
  corpPublicYn: '', // 상장여부
  corpPublicGb: '',// 상장구분
  corpPublicText: '', // 상장구분 기타
  homeUrl: '', // 홈페이지
  ciImgName: '', // 로고이미지명
  ciImgSize: '', // 로고이미지용량
  ciImgDir: '', // 로고이미지위치
  bizLicenseName: '', // 사업자등록증명
  bizLicenseSize: '', // 사업자등록증용량
  bizLicenseDir: '', // 사업자등록증위치
  corpIntro: '', // 기업소개
  corpHistory: '', // 주요연혁
  corpIntroName: '', // 기업소개서명
  corpIntroSize: '', // 기업소개서용량
  corpIntroDir: '', // 기업소개서위치
});

const errorInputCorp = ref({
  bizNum: '', // 사업자등록번호
  corpName: '', // 기업명
  ceoName: '', // 대표자명
  residenceArea: '', // 사업장소재지
  bizType: '', // 업종
  industryGb: '', // 산업군
  corpGb: '', // 기업형태
  foundYm: '', // 창립연월
  employeeNumGb: '', // 사원수
  salesAmtGb: '', // 매출액
  corpPublicYn: '', // 상장여부
  corpPublicGb: '', // 상장구분
  homeUrl: '', // 홈페이지 URL
  ciImg: '', // 로고이미지(CI)
  bizLicense: '', // 사업자등록증
  corpHistory: '' // 기업 추가 정보 - 주요 연혁
});

// 참가신청 정보 관리
const recruDetail = ref({
  // 참가 신청 정보
  joinPurpose: '', // 참가 목적
  intvInYn: '', // 면접 가능 유무
  intvAbleDay: '', // 면접가능일
  intvGb: '', // 면접방식
  fileYn: '', // 회사이력서파일유무
  corpResumeAttaches: [], // 회사이력서파일
  recruitCnt: 0, // 모집인원
  // 참가 신청 담당자 정보
  chargeName: '', // 참가신청 담당자 이름
  chargeDepart: '', // 참가신청 담당자 부서
  chargeJob: '', // 참가신청 담당자 직위
  chargeCompanyNum: '', // 참가신청 담당자 회사 직통번호
  chargePhoneNum: '', // 참가신청 담당자 휴대전화
  chargeEmail: '', // 참가신청 담당자 이메일
});
const errorInputRecru = ref({
  // 참가 신청 정보
  joinPurpose: '', // 참가목적
  intvAbleDay: '', // 면접일
  intvGb: '', // 면접방식
  fileYn: '', // 회사이력서파일유무
  corpResumeAttaches: '', // 회사이력서파일
  recruitCnt: '', // 모집인원
  // 참가 신청 담당자 정보
  chargeName: '', // 담당자 성명
  chargeDepart: '', // 담당자 부서
  chargeJob: '', // 담당자 직위
  chargeCompanyNum: '', // 담당자 회사 직통번호
  chargePhoneNum: '', // 담당자 휴대전화
  chargeEmail: '', // 담당자 이메일
})

const corpResumeAttaches = () => {
  recruDetail.value.corpResumeAttaches.push({
    attachSeq: 0,
    fileName: '',
    fileSize: '',
    fileDir: '',
    fileOrder: 0,
    deleteYn: ''
  })
}

// 모달
const jobFairResumeOpenModal = ref(null)
const lecturePlayerModal = ref(null)
const lectureResumeModal = ref(null)
const lectureSurveyModal = ref(null)
const jobFairResumeModal = ref(null); // 특별채용관 이력서
const jobNoticeModal = ref(null); // 채용공고
const jobNoticeListModal = ref(null); // 채용공고 목록

// 특별채용관 상세 조회
const ojfDetailByIdAndCorpId = (id) => {
  return jobFairCorpService.ojfDetailByIdAndCorpIdForMyPage(id);
}

// 탭 비활성화 여부 확인
const isDisabled = (tab) => {
  if (jobDetail.value.joinStateGb === '11') {
    return false; // 11일 때는 모두 활성화
  } else {
    return ![0, 1, 2, 3].includes(tab.value);
  }
};

const onSelectTab = (option) => {
  if (!isDisabled(option)) {
    tabIndex.value = option.value;
    currentPage.value = 1;
    currentPageDepth2.value = 1;
  }

  if (tabIndex.value === 1) { // 기업정보 관리
    ojfCorporationDetail();
    setViewMode('JOB_FAIR');
  } else if (tabIndex.value === 2) { // 참가신청 정보 관리
    ojfIntvDay(jobDetail.value.ojfId); // 면접 가능일 조회
    ojfCorpRecruitmentHall();
    setViewMode('JOB_FAIR');
  } else if (tabIndex.value === 3) {
    ojfCropJobNoticeList(); // 채용공고 관리 및 지원 현황
    setViewMode('JOB_FAIR');
  } else if (tabIndex.value === 4) {
    ojfCropInterestEntryList(); // 관심 인재
    ojfIntvDay(jobDetail.value.ojfId); // 면접 가능일 조회
    setViewMode('JOB_FAIR');
  } else {
    ojfCropInterviewProposalList(); // 면접제안 인재
    setViewMode('JOB_FAIR');
  }
}

// 페이징 개수 변경
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;

  if(tabIndex.value === 3) { // 채용공고 관리 및 지원 현황
    ojfCropJobNoticeList();
    pageSize.value = 10;
  } else if (tabIndex.value === 4) {
    ojfCropInterestEntryList();
    pageSize.value = 10;
  } else {
    ojfCropInterviewProposalList();
    pageSize.value = 10;
  }
}

// 페이지 클릭
const onSelectPage = (pageNo, depth) => {
  if(depth === 2) {
    currentPageDepth2.value = pageNo;
  } else {
    currentPage.value = pageNo;
  }

  if(tabIndex.value === 3) { // 채용공고 관리 및 지원 현황
    if(viewMode.value === RETRIEVE_APPLICANT) {
      ojfCropRetrieveApplicantList(detailCommonId.value);
    } else {
      ojfCropJobNoticeList();
    }
  } else if (tabIndex.value === 4) {
    ojfCropInterestEntryList();
  } else {
    ojfCropInterviewProposalList();
  }
}

// 탭 상세 화면 보기 조건
const setViewMode = (viewName, commonId, commonData) => {
  viewMode.value = viewName;

  // 채용공고 관리 및 지원현황 > 입사지원에서 사용할 데이터 들
  detailCommonId.value = commonId; // jobNoticeSeq
  detailCommonData.value = commonData; // fileYn,

  if(viewName === 'CORP_UPDATE') { // 기업정보 관리 수정
    ojfCorporationDetail();
  } else if (viewName === 'RECRUITMENT_HALL') { // 참가신청 정보 관리
    // 선택한 면접 날짜 가져오기
    const selectedDays = recruDetail.value.intvAbleDay?.split(',').map(day => day.trim()) || []

    setTimeout(() => {
      // 면접 가능 전체 날짜
      const allLabels = intvDays.value.map(day => day.label)

      if (recruDetail.value.intvInYn === 'Y') {
        // 면접 가능일내 날짜

        // "전체" 선택 여부 판단
        const isAll = selectedDays.length === allLabels.length &&
            selectedDays.every(day => allLabels.includes(day))

        if (isAll) {
          onClickAll(true)
        } else {
          isAllActive.value = false
          isEtcActive.value = false
          recruDetail.value.intvInYn = 'Y'

          intvDays.value.forEach(day => {
            day.on = selectedDays.includes(day.label)
          })
        }

        if(_.isEmpty(recruDetail.value.corpResumeAttaches)) {
          corpResumeAttaches();
        }
      } else {
        // 그 외
        onClickEtc(true)
      }
    }, 100)
  } else if (viewName === 'RETRIEVE_APPLICANT') { // 입사지원 목록
    currentPageDepth2.value = 1;
    ojfCropRetrieveApplicantList(commonId);
  }
}

// s : 기업정보 관리
// 조회
const ojfCorporationDetail = () => {
  loadingStore.loading = true;
  jobFairCorpService.ojfCorporationDetail(jobDetail.value.corpId)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          corpDetail.value.setCorpInfo(result);
          corpUpdate.value = result;

          // 사업자등록번호
          if(result.bizNum ) {
            const bizNum = result.bizNum;
            if(bizNum) {
              result.bizNum = bizNum.substring(0,3) + '-' + bizNum.substring(3,5) + '-' + bizNum.substring(5);
            }
          }

          // 사업장소재지
          if(result.residenceArea1 && result.residenceArea2) {
            residenceAreaRef.value?.initSelectedOption(result.residenceArea1, result.residenceArea2)
          }

          // 창립연월
          if(result.foundYm ) {
            const foundYm = result.foundYm;
            if(foundYm) {
              result.foundYm = foundYm.substring(0,4) + '.' + foundYm.substring(4,6);
            }
          }
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 사업자등록번호
const bizNumInput = ref('')

const formatBizNum = (event) => {
  // 숫자만 필터링
  bizNumInput.value = event.target.value.replace(/\D/g, '').slice(0, 6)

  // YYYY.MM 형식으로 포맷팅
  if (bizNumInput.value.length >= 5) {
    corpUpdate.bizNum = `${bizNumInput.value.slice(0, 3)}-${bizNumInput.value.slice(0,2)}-${bizNumInput.value.slice(5)}`
  } else {
    corpUpdate.bizNum = bizNumInput.value
  }
}

// 사업장소재지
const onSelectedArea1Option = (option) => {
  corpUpdate.value.residenceArea1 = option;
  errorInputCorp.value.residenceArea = '';
}

const onSelectedArea2Option = (option) => {
  corpUpdate.value.residenceArea2 = option;
  errorInputCorp.value.residenceArea = '';
}

// 상장여부 초기화
const resetCorpPublic = (val) => {
  if (val === 'N') {
    corpUpdate.value.corpPublicGb = ''
    corpUpdate.value.corpPublicText = ''
  }
}

// 상장 기타 초기화
const resetCorpPublicText = (val) => {
  if (val === '05') {
    corpUpdate.value.corpPublicText = ''
  }
}

// 산업군 기타 초기화
const resetIndustryText = (val) => {
  if (val === '06') {
    corpUpdate.value.industryText = ''
  }
}

// 기업형태 기타 초기화
const resetCorpText = (val) => {
  if (val === '05') {
    corpUpdate.value.corpText = ''
  }
}

// 로고이미지(CI) 업로드
const uploadFileCiImg = (corpUpdate) => {
  errorInputCorp.value.ciImg = '';
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'public',
      folder: 'ciImg',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            corpUpdate.ciImgName = result.originalFilename;
            corpUpdate.ciImgSize = result.fileSize;
            corpUpdate.ciImgDir = result.blobUrl;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 로고이미지(CI) 삭제
const removeFileCiImg = (corpUpdate) => {
  corpUpdate.ciImgName = '';
  corpUpdate.ciImgSize = '';
  corpUpdate.ciImgDir = '';
  errorInputCorp.value.ciImg = '';
}

// 사업자등록증 업로드
const uploadFileBizLicense = (corpUpdate) => {
  errorInputCorp.value.bizLicense = '';
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'bizLicense',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            corpUpdate.bizLicenseName = result.originalFilename;
            corpUpdate.bizLicenseSize = result.fileSize;
            corpUpdate.bizLicenseDir = result.blobUrl;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 사업자등록증 삭제
const removeFileBizLicense = (corpUpdate) => {
  corpUpdate.bizLicenseName = '';
  corpUpdate.bizLicenseSize = '';
  corpUpdate.bizLicenseDir = '';
  errorInputCorp.value.bizLicense = '';
}

// 기업소개서 업로드
const uploadFileCorpIntro = (corpUpdate) => {
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'corpIntro',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            corpUpdate.corpIntroName = result.originalFilename;
            corpUpdate.corpIntroSize = result.fileSize;
            corpUpdate.corpIntroDir = result.blobUrl;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 기업소개서 삭제
const removeFileCorpIntro = (corpUpdate) => {
  corpUpdate.corpIntroName = '';
  corpUpdate.corpIntroSize = '';
  corpUpdate.corpIntroDir = '';
}

// 수정 완료
const updateCorporation = () => {
  let isInvalid = false;
  let corpId = jobDetail.value.corpId;

  // 기본 기본 정보
  // 사업자등록번호
  const bizNum = corpUpdate.value.bizNum ? corpUpdate.value.bizNum.replace('-','').replace('-','') : corpUpdate.value.bizNum;
  if(!bizNum || bizNum.length !== 10) {
    errorInputCorp.value.bizNum = !bizNum ? '사업자등록번호를 입력하세요.' : '10자리 숫자를 입력하세요.';
    isInvalid = true;
  } else if (userBizNum !== corpUpdate.value.bizNum) {
    $alert(["소속 기업을 변경할 수 없습니다.", "관리자에게 문의해주세요."]);
    errorInputCorp.value.bizNum = '관리자에게 문의해주세요.';
    isInvalid = true;
  }

  // 기업명, 대표자명, 사업장소재지, 업종
  const { corpName, ceoName, residenceArea1, residenceArea2, bizType } = corpUpdate.value;
  errorInputCorp.value.bizNum = '';
  errorInputCorp.value.ceoName = '';
  errorInputCorp.value.residenceArea = '';
  errorInputCorp.value.bizType = '';

  // 기업명
  if(!corpName) {
    errorInputCorp.value.corpName = '기업명을 입력하세요.';
    isInvalid = true;
  }

  // 대표자명
  if(!ceoName) {
    errorInputCorp.value.ceoName = '대표자명을 입력하세요.';
    isInvalid = true;
  }

  //사업장소재지
  if((residenceArea1 === '' || residenceArea1 === '시/도 선택') ||
      (residenceArea2 === '' || residenceArea2 === '시/구/군 선택') ) {
    errorInputCorp.value.residenceArea = (residenceArea1 === '' || residenceArea1 === '시/도 선택') ? '시/도를 선택하세요.' : '시/구/군을 선택하세요.';
    isInvalid = true;
  }

  // 업종
  if(!bizType) {
    errorInputCorp.value.bizType = '업종을 입력하세요.';
    isInvalid = true;
  }

  // 산업구분, 기업형태, 창립연월, 사원수(인원구분), 매출액
  const { industryGb, corpGb, employeeNumGb, salesAmtGb } = corpUpdate.value;
  errorInputCorp.value.industryGb = '';
  errorInputCorp.value.corpGb = '';
  errorInputCorp.value.foundYm = '';
  errorInputCorp.value.employeeNumGb = '';
  errorInputCorp.value.salesAmtGb = '';

  // 산업군
  let industryText = corpUpdate.value.industryText;
  if(!industryGb) {
    errorInputCorp.value.industryGb = '산업군을 선택하세요.';
    isInvalid = true;
  } else if(industryGb === '06' && !industryText) {
    errorInputCorp.value.industryGb = '기타 산업군을 입력하세요.';
    isInvalid = true;
  } else if (industryGb !== '06') {
    industryText = '';
  }

  // 기업형태
  let corpText = corpUpdate.value.corpText;
  if(!corpGb) {
    errorInputCorp.value.corpGb = '기업형태를 선택하세요.';
    isInvalid = true;
  } else if(corpGb === '05' && !corpText) {
    errorInputCorp.value.corpGb = '기타 기업형태를 입력하세요.';
    isInvalid = true;
  } else if(corpGb !== '05') {
    corpText = '';
  }

  // 창립연월
  const foundYm = moment(corpUpdate.value.foundYm.replace('.', '')).format("YYYYMM")
  if(!foundYm) {
    errorInputCorp.value.foundYm = '창립연월을 입력하세요.';
    isInvalid = true;
  } else if (foundYm) {
    // console.log(foundYm);
    if(foundYm.length !== 6) {
      errorInputCorp.value.foundYm = '기간을 YYYY.MM 형식으로 입력하세요.';
      isInvalid = true;
    } else if(foundYm === 'Invalid date'  // 존재하지 않은 기간
        // || Number(nowYm) < Number(startYm)  // 미래 기간
    ) {
      errorInputCorp.value.foundYm = '올바른 기간을 입력하세요.';
      isInvalid = true;
    }
  }

  // 사원수(인원구분)
  if(!employeeNumGb || employeeNumGb === '00') {
    errorInputCorp.value.employeeNumGb = '사원수를 선택하세요.';
    isInvalid = true;
  }

  // 매출액
  if(!salesAmtGb || salesAmtGb === '00') {
    errorInputCorp.value.salesAmtGb = '매출액을 선택하세요.';
    isInvalid = true;
  }

  // 상장, 홈페이지 url
  const { corpPublicYn, corpPublicGb, homeUrl } = corpUpdate.value;
  errorInputCorp.value.corpPublicYn = '';
  errorInputCorp.value.corpPublicGb = '';

  // 상장
  let corpPublicText = corpUpdate.value.corpPublicYn;
  if(!corpPublicYn) {
    errorInputCorp.value.corpPublicYn = '상장여부를 선택하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && !corpPublicGb) {
    errorInputCorp.value.corpPublicGb = '상장여부를 선택하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && corpPublicGb === '05' && !corpPublicText) {
    errorInputCorp.value.corpPublicGb = '기타 상장을 입력하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && corpPublicGb !== '05') {
    corpPublicText = '';
  }

  // 로고이미지(CI)
  const { ciImgName, ciImgSize, ciImgDir } = corpUpdate.value;
  errorInputCorp.value.ciImg = '';

  if(!ciImgName || !ciImgSize || !ciImgDir) {
    errorInputCorp.value.ciImg = '로고이미지 파일을 선택하세요.';
    isInvalid = true;
  }

  // 사업자등록증
  const { bizLicenseName, bizLicenseSize, bizLicenseDir } = corpUpdate.value;
  errorInputCorp.value.bizLicense = '';

  if(!bizLicenseName || !bizLicenseSize || !bizLicenseDir) {
    errorInputCorp.value.bizLicense = '사업자등록증 파일을 선택하세요.';
    isInvalid = true;
  }

  // 기업 추가 정보 (기업 소개, 주요 연혁, 기업 소개서)
  const { corpIntro, corpHistory, corpIntroName, corpIntroSize, corpIntroDir } = corpUpdate.value;

  if(isInvalid) {
    $alert(["필수 입력사항을 확인해 주세요."]);
    isInvalid = true;
  }

  // 저장 처리
  if(!isInvalid) {
    jobFairCorpService.ojfUpdateCorporation(
        corpId, bizNum, corpName, ceoName, residenceArea1, residenceArea2,
        bizType, industryGb, industryText, corpGb, corpText,
        foundYm, employeeNumGb, salesAmtGb, corpPublicYn, corpPublicGb, corpPublicText,
        homeUrl, ciImgName, ciImgSize, ciImgDir,
        bizLicenseName, bizLicenseSize, bizLicenseDir,
        corpIntro, corpHistory, corpIntroName, corpIntroSize, corpIntroDir,
    ).then(async (res) => {
      loadingStore.loading = false;

      if (res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;

        setViewMode(JOB_FAIR);
        ojfCorporationDetail();

        $alert(["수정이 완료되었습니다."]);
      }
    }).catch((error) => {
      loadingStore.loading = false;
      console.log(error);
    });
  }
}
// e : 기업정보 관리

// s : 참가신청 정보 관리
// 조회
const ojfCorpRecruitmentHall = () => {
  loadingStore.loading = true;

  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    corpId: jobDetail.value.corpId,
  }

  jobFairCorpService.ojfCorpRecruitmentHall(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          recruDetail.value = result;
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 면접 가능일 전체인지 확인 후 문구 표시
// 참가신청 정보 관리
const allDays = computed(() => recruDetail.value.intvAbleDay.split(','))
const isAllSelected = computed(() => intvDays.value.length === allDays.value.length)
// 채용공고 관리 및 지원 현황 > 채용공고
const allDays2 = computed(() => applicantList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected2 = computed(() => intvDays.value.length === allDays2.value.length)
// 관심인재
const allDays3 = computed(() => interestEntryList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected3 = computed(() => intvDays.value.length === allDays3.value.length)
// 면접제안 인재
const allDays4 = computed(() => interviewProposaList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected4 = computed(() => intvDays.value.length === allDays4.value.length)


// 수정
// 면접 가능일 조회
const ojfIntvDay = async (ojfId) => {
  loadingStore.loading = true;
  await jobFairUserService.ojfIntvDay(ojfId)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          if (result !== null && result !== '') {
            const selectedDays = result.split(',').map(d => d.trim());

            intvDays.value = selectedDays.map(day => ({
              label: day,
              on: false
            }));
          }
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 면접 가능일 클릭
const onClickIntvDay = (clickedDay) => {
  errorInputRecru.value.intvAbleDay = '';
  isEtcActive.value = false
  recruDetail.value.intvInYn = 'Y';

  if (isAllActive.value) {
    // 전체 모드 해제 → 클릭한 날짜만 on
    isAllActive.value = false
    recruDetail.value.intvInYn = 'Y';

    intvDays.value.forEach(day => {
      day.on = (day === clickedDay)
    })
  } else {
    // 전체 상태가 아닐 때는 토글만
    clickedDay.on = !clickedDay.on

    // 날짜 전체가 선택되었는지 확인
    const allSelected = intvDays.value.every(day => day.on)
    isAllActive.value = allSelected
  }
}

// 면접 가능일 전체
const onClickAll = (force) => {
  errorInputRecru.value.intvAbleDay = ''

  if (isAllActive.value && !force) {
    isAllActive.value = false
    isEtcActive.value = false
    recruDetail.value.intvInYn = 'Y';

    intvDays.value.forEach(day => {
      day.on = false
    })
  } else {
    isAllActive.value = true
    isEtcActive.value = false
    recruDetail.value.intvInYn = 'Y';

    intvDays.value.forEach(day => {
      day.on = true
    })
  }
}

// 면접 가능일 외
const onClickEtc = (force) => {
  errorInputRecru.value.intvAbleDay = ''

  if (isEtcActive.value && !force) {
    isEtcActive.value = false
    recruDetail.value.intvInYn = 'Y'
  } else {
    isEtcActive.value = true
    isAllActive.value = false
    recruDetail.value.intvInYn = 'N'

    intvDays.value.forEach(day => {
      day.on = false
    })
  }
}

// 회사 이력서 양식 업로드
const uploadFileCorpResume = () => {
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'corpResumeAttaches',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            recruDetail.value.corpResumeAttaches[0].fileName = result.originalFilename;
            recruDetail.value.corpResumeAttaches[0].fileSize = result.fileSize;
            recruDetail.value.corpResumeAttaches[0].fileDir = result.blobUrl;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 회사 이력서 양식 삭제
const removeFileCorpResume = () => {
  recruDetail.value.corpResumeAttaches[0].fileName = '';
  recruDetail.value.corpResumeAttaches[0].fileSize = '';
  recruDetail.value.corpResumeAttaches[0].fileDir = '';
  errorInputRecru.value.corpResumeAttaches = '';
}

// 이력서 양식 초기화
const resetFile = (val) => {
  errorInputRecru.value.fileYn = '';
  if (val === 'N') {
    recruDetail.value.corpResumeAttaches[0].fileName = ''
    recruDetail.value.corpResumeAttaches[0].fileDir = ''
    recruDetail.value.corpResumeAttaches[0].fileSize = ''
  }
}

const validateText = (key) => {
  if (key === 'corpName') {
    if (corpUpdate.value.corpName.trim() === '') {
      errorInputCorp.value.corpName = '기업명을 입력하세요.';
    } else if (corpUpdate.value.corpName.length > 500) {
      errorInputCorp.value.corpName = '기업명은 최대 500자까지 입력하세요.';
    } else {
      errorInputCorp.value.corpName = '';
    }
  } else if (key === 'ceoName') {
    if (corpUpdate.value.ceoName.trim() === '') {
      errorInputCorp.value.ceoName = '대표자명을 입력하세요.';
    } else if (corpUpdate.value.ceoName.length > 50) {
      errorInputCorp.value.ceoName = '대표자명은 최대 50자까지 입력하세요.';
    } else {
      errorInputCorp.value.ceoName = '';
    }
  } else if (key === 'bizType') {
    if (corpUpdate.value.bizType.trim() === '') {
      errorInputCorp.value.bizType = '업종을 입력하세요.';
    } else if (corpUpdate.value.bizType.length > 100) {
      errorInputCorp.value.bizType = '업종은 최대 100자까지 입력하세요.';
    } else {
      errorInputCorp.value.bizType = '';
    }
  } else if (key === 'foundYm') {
    errorInputCorp.value.foundYm = '' ? '창립연월을 입력하세요.' : '';
  } else if (key === 'homeUrl') {
    if (corpUpdate.value.homeUrl.length > 200) {
      errorInputCorp.value.homeUrl = '홈페이지 URL은 최대 200자까지 입력하세요.';
    } else {
      errorInputCorp.value.homeUrl = '';
    }
  } else if (key === 'corpHistory') {
    // if (corpUpdate.value.corpHistory.length > 4000) {
    //   errorInputCorp.value.corpHistory = '주요 연혁은 최대 4000자까지 입력하세요.';
    // } else {
    //   errorInputCorp.value.corpHistory = '';
    // }
  } else if (key === 'recruitCnt') {
    errorInputRecru.value.recruitCnt = '' ? '모집인원을 입력하세요.' : '';
  } else if (key === 'chargeName') {
    if (recruDetail.value.chargeName.trim() === '') {
      errorInputRecru.value.chargeName = '성명을 입력하세요.';
    } else if (recruDetail.value.chargeName.length > 10) {
      errorInputRecru.value.chargeName = '성명은 최대 10자까지 입력하세요.';
    } else {
      errorInputRecru.value.chargeName = '';
    }
  } else if (key === 'chargeDepart') {
    if (recruDetail.value.chargeDepart.trim() === '') {
      errorInputRecru.value.chargeDepart = '부서를 입력하세요.';
    } else if (recruDetail.value.chargeDepart.length > 10) {
      errorInputRecru.value.chargeDepart = '부서는 최대 10자까지 입력하세요.';
    } else {
      errorInputRecru.value.chargeDepart = '';
    }
  } else if (key === 'chargeJob') {
    if (recruDetail.value.chargeJob.trim() === '') {
      errorInputRecru.value.chargeJob = '직위를 입력하세요.';
    } else if (recruDetail.value.chargeJob.length > 10) {
      errorInputRecru.value.chargeJob = '직위는 최대 10자까지 입력하세요.';
    } else {
      errorInputRecru.value.chargeJob = '';
    }
  } else if (key === 'chargeCompanyNum') {
    errorInputRecru.value.chargeCompanyNum = '' ? '회사 직통번호를 입력하세요.' : '';
  } else if (key === 'chargePhoneNum') {
    errorInputRecru.value.chargePhoneNum = '' ? '휴대폰 번호를 입력하세요.' : '';
  } else if (key === 'chargeEmail') {
    const email = recruDetail.value.chargeEmail.trim()
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (email === '') {
      errorInputRecru.value.chargeEmail = '이메일을 입력하세요.'
    } else if (email.length > 50) {
      errorInputRecru.value.chargeEmail = '이메일은 최대 50자까지 입력하세요.'
    } else if (!emailRegex.test(email)) {
      errorInputRecru.value.chargeEmail = '유효한 이메일 형식을 입력하세요.'
    } else {
      errorInputRecru.value.chargeEmail = ''
    }
  }
}

const optionData = (key) => {
  if (key === 'intvGb') {
    errorInputRecru.value.intvGb = '' ? '면접 방식을 선택하세요.' : '';
  }
}

// 특수문자 작성 안됨
const filterText = (value) => {
  return value.replace(/[^a-zA-Z0-9ㄱ-ㅎ가-힣\s]/g, ''); // 특수문자 제거
}

const onInputChange = (event, key) => {
  const filteredValue = filterText(event.target.value).slice(0, 200); // 글자수 제한 200자

  // 필터링된 값 적용
  recruDetail.value[key] = filteredValue;

  // 유효성 체크
  if (!filteredValue) {
    errorInputRecru.value[key] = '참가 목적을 입력하세요.';
  } else if (filteredValue.length > 200) {
    errorInputRecru.value[key] = '참가 목적은 최대 200자까지 입력하세요.';
  } else {
    errorInputRecru.value[key] = ''; // 유효성 통과시 에러 메시지 초기화
  }
}

// 수정 완료
const updateRecruitmentHall = () => {
  let isInvalid = false;
  let recruitmentHallSeq = recruDetail.value.recruitmentHallSeq;

  // 참가 신청 정보
  // 참가 목적
  const { joinPurpose } = recruDetail.value;
  errorInputRecru.value.joinPurpose = '';

  // ella : 참가 목적 숨김 요청 (20250904)
  // if(!joinPurpose) {
  //   errorInputRecru.value.joinPurpose = '참가 목적을 입력하세요.';
  //   isInvalid = true;
  // }

  // 면접 가능일
  const intvAbleDay = _.map(_.filter(intvDays.value, {'on': true}), 'label').join(',');

  const { intvInYn } = recruDetail.value;
  errorInputRecru.value.intvAbleDay = '';

  if(!intvInYn) {
    errorInputRecru.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  } else if (intvInYn === 'Y' && !intvAbleDay) {
    errorInputRecru.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  }

  // 면접 방식
  const { intvGb } = recruDetail.value;
  errorInputRecru.value.intvGb = '';

  if(!intvGb) {
    errorInputRecru.value.intvGb = '면접 방식을 선택하세요.';
    isInvalid = true;
  }

  // 이력서 양식, 회사 이력서 양식 첨부, 모집인원
  const { fileYn, recruitCnt } = recruDetail.value;
  const corpResumeAttaches =  _.filter(recruDetail.value.corpResumeAttaches, attach => {
    return attach.fileName !== null && attach.fileName !== '';
  })
  errorInputRecru.value.fileYn = '';
  errorInputRecru.value.corpResumeAttaches = '';
  errorInputRecru.value.recruitCnt = '';

  if(!fileYn) {
    errorInputRecru.value.fileYn = '면접 방식을 선택하세요.';
    isInvalid = true;
  } else if(fileYn === 'Y' && !corpResumeAttaches[0]) {
    errorInputRecru.value.corpResumeAttaches = '회사 이력서 양식을 첨부해주세요.';
    isInvalid = true;
  }

  // 모집인원
  if(!recruitCnt || recruitCnt === '0') {
    errorInputRecru.value.recruitCnt = '모집인원을 입력하세요.';
    isInvalid = true;
  }

  // 약관 동의
  const agreePrivacyYn = recruDetail.value.agreePrivacyYn ? 'Y' : 'N';
  errorInputRecru.value.agreePrivacyYn  = false;

  if(agreePrivacyYn === 'N') {
    $alert(["필수 약관을 확인하고 동의해 주세요."]);
    isInvalid = true;
  }

  // 참가 신청 담당자 정보
  const { chargeName, chargeDepart, chargeJob, chargeCompanyNum, chargePhoneNum } = recruDetail.value;
  errorInputRecru.value.chargeName  = '';
  errorInputRecru.value.chargeDepart  = '';
  errorInputRecru.value.chargeJob  = '';
  errorInputRecru.value.chargeCompanyNum  = '';
  errorInputRecru.value.chargePhoneNum  = '';
  errorInputRecru.value.chargeEmail  = '';

  // 성명
  if(!chargeName) {
    errorInputRecru.value.chargeName = '성명을 입력하세요.';
    isInvalid = true;
  }

  // 부서
  if(!chargeDepart) {
    errorInputRecru.value.chargeDepart = '부서를 입력하세요.';
    isInvalid = true;
  }

  // 직위
  if(!chargeJob) {
    errorInputRecru.value.chargeJob = '직위를 입력하세요.';
    isInvalid = true;
  }

  // 회사 직통번호
  if(!chargeCompanyNum) {
    errorInputRecru.value.chargeCompanyNum = '회사 직통번호를 입력하세요.';
    isInvalid = true;
  }
  // 20250924(ella): 회사 직통번호 밸리데이션 제거
  // } else if(!$regex.generalPhoneNum.test(chargeCompanyNum)) {
  //
  //   errorInputRecru.value.chargeCompanyNum = '회사 직통번호를 숫자로만 입력하세요.';
  //   isInvalid = true;
  // }

  // 휴대전화
  if(!chargePhoneNum || chargePhoneNum.length !== 13) {
    errorInputRecru.value.chargePhoneNum = '휴대전화를 입력하세요.';
    isInvalid = true;
  } else if(!$regex.phoneNum.test(chargePhoneNum)) {
    errorInputRecru.value.chargePhoneNum = '휴대전화를 숫자로만 입력하세요.';
    isInvalid = true;
  }

  // 이메일 형식 확인
  const chargeEmail = recruDetail.value.chargeEmail.trim()
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  // 이메일
  if(!chargeEmail) {
    errorInputRecru.value.chargeEmail = '이메일을 입력하세요.';
    isInvalid = true;
  } else if(!emailRegex.test(chargeEmail)) {
    errorInputRecru.value.chargeEmail = '유효한 이메일 형식을 입력하세요.';
    isInvalid = true;
  }

  if(isInvalid) {
    $alert(["필수 입력사항을 확인해 주세요."]);
    isInvalid = true;
  } else {
    loadingStore.loading = true;
    jobFairCorpService.ojfCropUpdateRecruitmentHall(
        recruitmentHallSeq,
        joinPurpose, intvInYn, intvAbleDay, intvGb,
        fileYn, corpResumeAttaches, recruitCnt,
        chargeName, chargeDepart, chargeJob, chargeCompanyNum,
        chargePhoneNum, chargeEmail, agreePrivacyYn,
    ).then( async (res) => {
      loadingStore.loading = false;

      if (res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;

        $alert(["수정이 완료되었습니다."]);

        setViewMode(JOB_FAIR);
        ojfCorpRecruitmentHall();
      }
    }).catch((error) => {
      loadingStore.loading = false;
      console.log(error);
    });
  }
}

// 참가신청 취소
const cancelEntry = async (recruitmentHallSeq, joinStateGb) => {
  const ok = await $confirm(["'신청 취소'로 상태가 변경됩니다."], "신청 취소");
  if(!ok) {
    return -1;
  }

  let paramObj = {
    recruitmentHallSeq: recruitmentHallSeq,
    joinStateGb: joinStateGb,
  }

  adminCorporationService.updateJoinStateBySeq(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          // const result = res.data.result;
          $alert(["참가 신청이 취소 되었습니다."]);
          router.push({ name: 'MyPageCorpOpenRecruitment'})
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}
// e : 참가신청 정보 관리

// s : 채용공고 관리 및 지원 현황
// 조회
const ojfCropJobNoticeList = () => {
  loadingStore.loading = true;
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
  }

  jobFairCorpService.ojfCropJobNoticeList(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          jobNoticeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 입사지원 목록
const ojfCropRetrieveApplicantList = (jobNoticeSeq) => {
  let paramObj = {
    jobNoticeSeq: jobNoticeSeq,
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPageDepth2.value || 0,
    size: pageSize.value || 10,
  }

  // loadingStore.loading = true;
  jobFairCorpService.ojfCropRetrieveApplicantList(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPagesDepth2.value = result.totalPages;
          totalCountDepth2.value = result.totalElements;
          applicantList.value = $pageListBoardNo(result.content, totalCountDepth2.value, pageSize.value, currentPageDepth2.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 입사지원 상태변경
const onClickApplyStateGb = async (resumeId, jobNoticeSeq, stateGb) => {
  let ok;
  if (stateGb === "03") {
    ok = await $confirm(["서류합격 처리하시겠습니까??", "'서류합격'으로 상태가 변경됩니다."], "서류 합격");
  } else if (stateGb === "04") {
    ok = await $confirm(["서류불합격 처리하시겠습니까??", "'서류불합격'으로 상태가 변경됩니다."], "서류 불합격");
  } else if (stateGb === "05") {
    ok = await $confirm(["최종합격 처리하시겠습니까??", "'최종합격'으로 상태가 변경됩니다."], "최종 합격");
  } else if (stateGb === "06") {
    ok = await $confirm(["최종불합격 처리하시겠습니까??", "'최종불합격'으로 상태가 변경됩니다."], "최종 불합격");
  } 
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      resumeId: resumeId,
      ojfId: jobDetail.value.ojfId,
      jobNoticeSeq: jobNoticeSeq,
      applyStateGb: stateGb,
    }
    jobFairUserService.ojfUpdateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            $alert(["변경 하였습니다."]);
            //$toast('', "삭제를 하였습니다.")
            ojfCropRetrieveApplicantList(jobNoticeSeq);
          } else {
            $alert(["변경을 실패하였습니다."]);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      $alert(["변경을 실패하였습니다."]);
    });
  }
}

// 엑셀

// 엑셀
const downloadUserResumeList = (jobNoticeSeq) => {
  loadingStore.loading = true;
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    jobNoticeSeq: jobNoticeSeq,
  }

  jobFairCorpService.ojfCorpUserResumeExcel(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        try {
          const href = URL.createObjectURL(res.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', `${moment().format("YYYYMMDD")}_입사지원리스트.xlsx`); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        } catch(e) {
          console.error('다운로드 파일 처리 중 오류가 발생했습니다:', e);
        }
      }).catch( (err) =>  {
    loadingStore.loading = false;
    let errorMessage = '다운로드 데이터 생성 중 오류가 발생했습니다.';
    // Blob 응답 처리
    err.response.data.text()  // Blob을 텍스트로 변환
        .then(text => {
          try {
            // 텍스트를 JSON으로 파싱
            const responseData = JSON.parse(text);
            // 메시지 추출
            if (responseData?.result?.message) {
              errorMessage = responseData.result.message;
            }
          } catch (parseError) {
            console.error('에러 메시지 파싱 중 오류가 발생했습니다.:', parseError);
          }
          // Toast에 에러 메시지 표시
          $toast('error', errorMessage);
        });
  });
}
// e : 채용공고 관리 및 지원 현황

// s : 관심인재
// 조회
const ojfCropInterestEntryList = () => {
  loadingStore.loading = true;
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
  }

  jobFairCorpService.ojfCropInterestEntryList(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          interestEntryList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 관심 삭제
const onClickDeleteInterestYn = async (resumeId) => {
  const ok = await $confirm(["관심인재를 삭제하시겠습니까?"], "관심인재 삭제");
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      ojfId: jobDetail.value.ojfId,
      resumeId: resumeId,
      interestYn: "N",
    }
    jobFairCorpService.ojfCropInterestEntryYn(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            $alert(["삭제를 하였습니다."]);
            //$toast('', "삭제를 하였습니다.")
            ojfCropInterestEntryList();
          } else {
            $alert(["삭제를 실패하였습니다."]);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      $alert(["삭제를 실패하였습니다."]);
    });
  }
}

// 면접제안 등록
const onClickInterviewProposal = async (resumeId) => {
  const ojfId = jobDetail.value.ojfId;
  const corpId = jobDetail.value.corpId;
  const mode = 'mypage'

  // 면접제안 확인 (0이면 제안한적 없음, 0초과면 제안이 있는)
  let paramObj = {
    ojfId: ojfId,
    corpId: corpId,
    resumeId: resumeId,
  }
  jobFairCorpService.ojfCropInterviewProposalEntryCnt(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          if (result > 0) {
            // modalContent.value = ["이미 '면접제안'이 완료된 '이력서'입니다."];
            // await modal.value.show();

            jobNoticeListModal.value.init()
            jobNoticeListModal.value.interviewProposalJobNoticeList(ojfId, resumeId, mode);

            jobNoticeListModal.value.show();
          } else {
            jobNoticeListModal.value.init()
            jobNoticeListModal.value.interviewProposalJobNoticeList(ojfId, resumeId, mode);
            jobNoticeListModal.value.show();
          }
        } else {
          console.log(res);
        }
      }).catch( (res) =>  {
    loadingStore.loading = false;
    console.log(res);
  });
}
// e : 관심인재


// s : 면접제안 인재
// 조회
const ojfCropInterviewProposalList = () => {
  loadingStore.loading = true;
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
  }

  jobFairCorpService.ojfCropInterviewProposalList(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          interviewProposaList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 받은 면접제안 상태변경
const onClickIntvPropState = async (resumeId, jobNoticeSeq, stateGb) => {
  let ok;
  if(stateGb === '04') {
    ok = await $confirm(["제안을 취소 하시겠습니까?", "'제안취소'로 상태가 변경됩니다."], "제안취소");
  } else if(stateGb === '05') {
    ok = await $confirm(["최종합격 처리하시겠습니까?", "'최종합격'으로 상태가 변경됩니다."], "최종합격");
  } else if(stateGb === '06') {
    ok = await $confirm(["최종불합격 처리하시겠습니까?", "'최종불합격'으로 상태가 변경됩니다."], "최종불합격");
  }
  
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      resumeId: resumeId,
      jobNoticeSeq: jobNoticeSeq,
      intvPropStateGb: stateGb,
    }

    // console.log(paramObj)
    jobFairUserService.ojfUpdateIntvPropsState(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            $alert(["변경 하였습니다."]);
            ojfCropInterviewProposalList();
          } else {
            $alert(["변경을 실패하였습니다."]);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      $alert(["변경을 실패하였습니다."]);
    });
  }
}
// e : 면접제안 인재

// 이력서 보기
const onClickMyResume = (resumeId, ojfId, delYn) => {
  const mode = 'mypageOpenRecruitment';

  if (delYn === 'Y') {
    $alert(["삭제된 이력서 입니다."]);
  } else {
    jobFairResumeModal.value.init(false, undefined, undefined, undefined, undefined, undefined, undefined, mode);
    jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId);
    jobFairResumeModal.value.show();
  }
}

// 관심인재 이력서 보기
const onClickInterestMyResume = (resumeId, ojfId, interestYn) => {
  const corpId = jobDetail.value.corpId;
  const mode = 'mypageOpenRecruitment';

  jobFairResumeModal.value.init(false, true, interestYn, undefined, undefined, undefined, undefined, mode);
  jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId, corpId);
  jobFairResumeModal.value.show();
}

// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, applicantCnt) => {
  const joinStateGb = jobDetail.value.joinStateGb;
  const ojfId = jobDetail.value.ojfId;
  const corpId = jobDetail.value.corpId;
  const mode = 'openRecruitment'
  if (applicantCnt >= 0) { // 채용공고 관리 및 지원현황 에서 데이터 받음
    jobNoticeModal.value.init(true, false, false, 0, 0, 0, 0, applicantCnt, joinStateGb, mode);
  } else {
    jobNoticeModal.value.init(true, false, false);
  }
  jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
  jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId, corpId);
  jobNoticeModal.value.ojfCorporationDetail(corpId);
  await jobNoticeModal.value.show();

  ojfCropJobNoticeList();
}

// 채용공고 등록
const onClickJobNoticeCreate = () => {
  const id = jobDetail.value.ojfId;
  const mode = 'openRecruitment';
  router.push({ name: 'MyPageCorpJobNoticeCreat', query : { ojfId: id, mode: mode } });
}

// 채용공고 수정
const onClickChangeJobNotice = (jobNoticeSeq) => {
  const mode = 'openRecruitment';
  router.push({ name: 'MyPageCorpJobNotice', query : { jobNoticeSeq: jobNoticeSeq, mode: mode }})
}

// 채용공고 삭제
const onClickDelete = async (jobNoticeSeq) => {
  const ok = await $confirm(["채용공고를 삭제하시겠습니까?"], "삭제");
  if(!ok) {
    return -1;
  } else {
    jobFairCorpService.ojfCropJobNoticeDelete ( jobNoticeSeq )
        .then((res) => {
          loadingStore.loading = true;
          if(res.data.code.toLowerCase() === 'success') {
            $alert(["채용공고가 삭제되었습니다."]);
            ojfCropJobNoticeList();
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      // console.log(res);
      $alert([res.response.data.result.message]);
    });
  }
}

// 취소
const clickCancel = () => {
  setViewMode(JOB_FAIR)
  ojfCorporationDetail(); // 기업정보 관리
  ojfCorpRecruitmentHall(); // 참가신청 정보 관리

  $alert(["수정이 취소되었습니다."]);
}

// 엑셀 다운로드
const onClickExcelDownload = async (jobNoticeSeq) => {
  if(totalCount.value > 0) {
    const ok = await $confirm(["입사지원 목록을 내 PC로 다운로드할까요?"], "다운로드");
    if(ok){
      downloadUserResumeList(jobNoticeSeq);
    }
  } else {
    $alert(["다운로드 받을 '입사지원 목록'이 존재하지 않습니다."]);
    return false;
  }
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <!-- S : 강의 상세-->
        <div class="content">
          <div class="lecture-wrap">
            <div class="sub-title grid space-between">
              <h3>
                <span class="badge" :class="{'jobstate0': (jobDetail.ojfStateGb === '00' || jobDetail.ojfStateGb === '02'), 'jobstate2': jobDetail.ojfStateGb === '01', 'jobstate4': jobDetail.ojfStateGb === '03', 'jobstate5': jobDetail.ojfStateGb === '04'}">
                  {{ jobDetail.ojfStateGb === '00' ? '신청 대기' : jobDetail.ojfStateGb === '01' ? '신청 접수중' : jobDetail.ojfStateGb === '02' ? '신청마감' : jobDetail.ojfStateGb === '03' ? '행사 진행중' : '행사 종료' }}
                  <!-- 상태가 '03'일 때 -->
                  <span v-if="jobDetail.ojfStateGb === '03'">
                    {{ $isInRegPeriod(jobDetail.regStartYmd, jobDetail.regEndYmd) ? '(신청 접수중)' : ($isAfterRegEnd(jobDetail.regEndYmd) ? '(신청 마감)' : '') }}
                  </span>
                </span>{{ jobDetail.ojfName }}
              </h3>
              <div class="btn-wrap">
                <KSASecondaryButton class="gray_button" text="목록" @click="router.push({name: 'MyPageCorpOpenRecruitment'})" />
              </div>
            </div>
            <div class="lecture-summary">
              <div class="left-area">
                <div class="img">
                  <KSAImage :src="jobDetail.ojfThombDir"/>
                </div>
              </div>
              <div class="right-area btn-area">
                <div class="btn-wrap">
                  <KSASecondaryButton text="행사 상세 보기" @click="router.push({name: 'MatchingOpenRecruitmentDetail', params:{id: jobDetail.ojfId}})" />
                </div>
                <div class="info">
                  <p>
                    <span class="badge" :class="{'jobstate1': (jobDetail.joinStateGb === '03' || jobDetail.joinStateGb === '04'), 'jobstate2': jobDetail.joinStateGb === '01', 'jobstate3': jobDetail.joinStateGb === '02', 'jobstate4': jobDetail.joinStateGb === '11', 'jobstate5': jobDetail.joinStateGb === '21'}">{{ $gbNameKR('USER_JOIN_STATE_GB', jobDetail.joinStateGb) }}</span>
                  </p>
                  <p>
                    <span>접수기간</span>
                    <span v-if="jobDetail.regStartYmd && jobDetail.regEndYmd">{{ $yyyymmdd(jobDetail.regStartYmd) }} ~ {{ $yyyymmdd(jobDetail.regEndYmd) }}</span>
                    <span v-else>-</span>
                  </p>
                  <p>
                    <span>행사기간</span>
                    <span v-if="jobDetail.ojfStartYmd && jobDetail.ojfEndYmd">{{ $yyyymmdd(jobDetail.ojfStartYmd) }} ~ {{ $yyyymmdd(jobDetail.ojfEndYmd) }}</span>
                    <span v-else>-</span>
                  </p>
                  <p>
                    <span>면접기간</span>
                    <span>{{ jobDetail.ojfIntvDay || '-' }}</span>
                  </p>
                  <p>
                    <span>장소</span>
                    <span>{{ jobDetail.ojfPlace || '-' }}</span>
                  </p>
                  <p>
                    <span>주최</span>
                    <span>{{ jobDetail.ojfHost || '-' }}</span>
                  </p>
                  <p v-if="jobDetail.summary">
                    <small class="mt-sm">*{{ jobDetail.summary }}</small>
                  </p>
                </div>
              </div>
            </div>
            <KSATab class="tab-style_border" :options="tabOptions" :disabled="isDisabled" @change="onSelectTab"/>
            <div class="lecture-detail" v-show="viewMode === JOB_FAIR">
              <!-- s : 행사정보 -->
              <div v-if="tabIndex === 0">
                <div class="editor-wrap" v-html="jobDetail.ojfIntro"></div>
              </div>
              <!-- e : 행사정보 -->

              <!-- s : 기업정보 관리 -->
              <div class="table-form" v-if="tabIndex === 1">
                <MyPageCorpJobFairCorpInfoView ref="corpDetail" />
                <div v-if="jobDetail.ojfStateGb === '03' && jobDetail.joinStateGb === '11'" class="btn-wrap text-right mb-xs">
                  <KSASecondaryButton class="gray_button" text="수정" @click="setViewMode(CORP_UPDATE)" />
                </div>
              </div>
              <!-- e : 기업정보 관리 -->

              <!-- s : 참가신청 정보 관리 -->
              <div class="table-form" v-if="tabIndex === 2">
                <div class="state-box">
                  현재 참가 신청 상태 : <span>{{ $gbNameKR('USER_JOIN_STATE_GB', jobDetail.joinStateGb) }}</span>
                </div>
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">참가신청 정보</th>
                  </tr>
                  <!-- ella : 참가 목적 숨김 요청 (20250904) -->
<!--                  <tr>-->
<!--                    <th>참가 목적</th>-->
<!--                    <td>{{ recruDetail.joinPurpose }}</td>-->
<!--                  </tr>-->
                  <tr>
                    <th>면접 가능일</th>
                    <td class="word-break-all">
                      <span v-if="recruDetail.intvInYn === 'Y' && isAllSelected">
                        전체 일정 가능
                        [{{ recruDetail.intvAbleDay }}]
                      </span>
                      <span v-else-if="recruDetail.intvInYn === 'Y'">{{ recruDetail.intvAbleDay }}</span>
                      <p v-else>면접 일정 조율</p>
                    </td>
                  </tr>
                  <tr>
                    <th>면접 방식</th>
                    <td>{{ $gbNameKR('INTV_GB', recruDetail.intvGb) }}</td>
                  </tr>
                  <tr>
                    <th>이력서 양식</th>
                    <td>
                      <p v-if="recruDetail.fileYn === 'N'">협회 이력서</p>
                      <p v-else>회사 이력서</p>
                    </td>
                  </tr>
                  <tr v-if="recruDetail.fileYn === 'Y'">
                    <th>회사 이력서 양식 첨부</th>
                    <td>
                      <p class="file" v-for="corpResumeAttaches in recruDetail.corpResumeAttaches" @click="$downloadForPrivate({fileName:corpResumeAttaches.fileName, fileDir: corpResumeAttaches.fileDir })">
                        {{ corpResumeAttaches.fileName }}
                        <span v-if="corpResumeAttaches.fileSize">({{ $fileSize(corpResumeAttaches.fileSize) }})</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>모집인원</th>
                    <td>{{ recruDetail.recruitCnt }}명</td>
                  </tr>
                </table>
                <table class="vertical align-left mt-sm">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">참가 신청 담당자 정보</th>
                  </tr>
                  <tr>
                    <th>성명</th>
                    <td>{{ recruDetail.chargeName }}</td>
                  </tr>
                  <tr>
                    <th>부서</th>
                    <td>{{ recruDetail.chargeDepart }}</td>
                  </tr>
                  <tr>
                    <th>직위</th>
                    <td>{{ recruDetail.chargeJob }}</td>
                  </tr>
                  <tr>
                    <th>회사 직통번호</th>
                    <td>{{ recruDetail.chargeCompanyNum }}</td>
                  </tr>
                  <tr>
                    <th>휴대전화</th>
                    <td>{{ $phoneNum(recruDetail.chargePhoneNum) }}</td>
                  </tr>
                  <tr>
                    <th>이메일</th>
                    <td>{{ recruDetail.chargeEmail }}</td>
                  </tr>
                </table>
                <div v-if="jobDetail.joinStateGb !== '11' && jobDetail.joinStateGb !== '21'" class="btn-wrap space-between">
                  <KSASecondaryButton class="red_button" text="신청 취소" @click="cancelEntry(recruDetail.recruitmentHallSeq, '03')" />
                  <KSAPrimaryButton text="수정" @click="setViewMode(RECRUITMENT_HALL)" />
                </div>
              </div>
              <!-- e : 참가신청 정보 관리 -->

              <!-- s : 채용공고 관리 및 지원 현황 -->
              <div class="table-form" v-if="tabIndex === 3">
                <div class="list-top mb-n-xs">
                  <KSAPrimaryButton text="채용공고 등록" @click="onClickJobNoticeCreate" />
                </div>
                <div class="list-top">
                  <p>총 게시물 <span>{{ $number(totalCount)}}</span>건</p>
                  <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                </div>
                <div class="table-form">
                  <table class="table-form board-mobile-vertical" v-if="jobNoticeList !== null">
                    <tr>
                      <th>번호</th>
                      <th>채용공고 제목</th>
                      <th>입사지원</th>
                      <th>최근 수정일</th>
                      <th>등록일</th>
                      <th>관리</th>
                    </tr>
                    <tr v-for="list in jobNoticeList">
                      <td>{{ list.boardNo }}</td>
                      <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(list.jobNoticeSeq, list.applicantCnt)">{{ list.jobName }}</td>
                      <td class="clickable blue" @click="setViewMode(RETRIEVE_APPLICANT, list.jobNoticeSeq, list.fileYn)">{{ list.applicantCnt }}</td>
                      <td>{{ $yyyymmddHHmmss(list.modifyDate) }}</td>
                      <td>{{ $yyyymmddHHmmss(list.createDate) }}</td>
                      <td>
                          <!-- 승인/반려 처리 이전(01 신청 접수 완료 02 신청 검토중) = 수정가능, 삭제 불가 -->
                          <div v-if="jobDetail.joinStateGb === '01' || jobDetail.joinStateGb === '02'">
                              <KSATextButton class="clickable" text="수정" @click="onClickChangeJobNotice(list.jobNoticeSeq)"/>
                          </div>
                          <!-- 승인처리 이후(11) -->
                          <div v-else-if="jobDetail.joinStateGb === '11'">
                              <!-- 승인처리 이후(11) + 입사지원 없는 경우 = 수정가능, 삭제 가능 -->
                              <div v-if="list.applicantCnt === 0">
                                  <KSATextButton class="clickable mr-xs" text="수정" @click="onClickChangeJobNotice(list.jobNoticeSeq)"/>
                                  <KSATextButton class="clickable red_button" text="삭제" @click="onClickDelete(list.jobNoticeSeq)"/>
                              </div>
                              <div v-else>-</div>
                          </div>
                          <!-- 반려 처리 이후 = 수정가능(의미없음), 삭제 가능 -->
                          <div v-else-if="jobDetail.joinStateGb === '21'">
                              <KSATextButton class="clickable mr-xs" text="수정" @click="onClickChangeJobNotice(list.jobNoticeSeq)"/>
                              <KSATextButton class="clickable red_button" text="삭제" @click="onClickDelete(list.jobNoticeSeq)"/>
                          </div>
                          <div v-else> - </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="result-none lecture-none" v-if="jobNoticeList.length === 0">
                  등록된 채용공고가 없습니다.
                </div>
                <Paginate
                    v-if="jobNoticeList.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
              </div>
              <!-- e : 채용공고 관리 및 지원 현황 -->

              <!-- s : 관심인재 -->
              <div class="table-form" v-if="tabIndex === 4">
                <div class="list-top">
                  <p>총 게시물 <span>{{ $number(totalCount)}}</span>건</p>
                  <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                </div>
                <div class="table-form">
                  <table class="table-form board-mobile-vertical" v-if="interestEntryList !== null">
                    <tr>
                      <th>번호</th>
                      <th>이름</th>
                      <th>이력서 제목</th>
                      <th>관심 카테고리</th>
                      <th>면접 가능일</th>
                      <th>관심 등록일</th>
                      <th>면접제안</th>
                      <th>관심 삭제</th>
                    </tr>
                    <tr v-for="list in interestEntryList">
                      <td>{{ list.boardNo }}</td>
                      <td>{{ list.userName }}</td>
                      <td>
                        <p class="file text-overflow long-overflow" v-if="list.fileYn === 'Y'" v-for="resumeAttaches in list.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                          {{ resumeAttaches.fileName }}
                        </p>
                        <p class="clickable blue text-overflow long-overflow" v-else @click="onClickInterestMyResume(list.resumeId, jobDetail.ojfId, list.interestYn)">
                          {{ list.title }}
                        </p>
                      </td>
                      <td>{{ list.interests }}</td>
                      <td class="word-break-all">
                        <span v-if="list.intvInYn === 'Y' && isAllSelected3">
                          전체 일정 가능
                          [{{ list.intvAbleDay }}]
                        </span>
                        <span v-else-if="list.intvInYn === 'Y'">{{ list.intvAbleDay }}</span>
                        <span v-else>면접 일정 조율</span>
                      </td>
                      <td>{{ $yyyymmddHHmmss(list.modifyDate) }}</td>
                      <td>
                        <KSATextButton text="면접제안" @click="onClickInterviewProposal(list.resumeId)"/>
                      </td>
                      <td>
                        <KSATextButton text="♥" @click="onClickDeleteInterestYn(list.resumeId)" class="red_button"></KSATextButton>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="result-none lecture-none" v-if="interestEntryList.length === 0">
                  등록된 관심인재가 없습니다.
                </div>
                <Paginate
                    v-if="interestEntryList.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
              </div>
              <!-- e : 관심인재 -->

              <!-- s : 면접제안 인재 -->
              <div class="table-form" v-if="tabIndex === 5">
                <div class="list-top">
                  <p>총 게시물 <span>{{ $number(totalCount)}}</span>건</p>
                  <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                </div>
                <div class="table-form">
                  <table class="table-form board-mobile-vertical" v-if="interviewProposaList !== null">
                    <tr>
                      <th>번호</th>
                      <th>이름</th>
                      <th>이력서 제목</th>
                      <th>관심 카테고리</th>
                      <th>면접 가능일</th>
                      <th>면접제안 공고 제목</th>
                      <th>제안일</th>
                      <th>상태</th>
                      <th>상태변경</th>
                    </tr>
                    <tr v-for="list in interviewProposaList">
                      <td>{{ list.boardNo }}</td>
                      <td>{{ list.userName }}</td>
                      <td>
                        <p class="file text-overflow" v-if="list.fileYn === 'Y'" v-for="resumeAttaches in list.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                          {{ resumeAttaches.fileName }}
                        </p>
                        <p class="clickable blue text-overflow long-overflow" v-else @click="onClickMyResume(list.resumeId, jobDetail.ojfId, list.delYn)">
                          {{ list.title }}
                        </p>
                      </td>
                      <td>{{ list.interests }}</td>
                      <td class="word-break-all">
                        <span v-if="list.intvInYn === 'Y' && isAllSelected4">
                          전체 일정 가능
                          [{{ list.intvAbleDay }}]
                        </span>
                        <span v-else-if="list.intvInYn === 'Y'">
                          {{ list.intvAbleDay }}
                        </span>
                        <span v-else>면접 일정 조율</span>
                      </td>
                      <td>
                        <p class="clickable blue text-overflow" @click="onClickJobNotice(list.jobNoticeSeq)">{{ list.jobName }}</p>
                      </td>
                      <td>{{ $yyyymmddHHmmss(list.createDate) }}</td>
                      <td>
                        <span v-if="list.intvPropStateGb === '01'">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',list.intvPropStateGb) }}</span>
                        <span v-else-if="list.intvPropStateGb === '02' || list.intvPropStateGb === '05'" class="blue">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',list.intvPropStateGb) }}</span>
                        <span v-else-if="list.intvPropStateGb === '03' || list.intvPropStateGb === '06'" class="red">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',list.intvPropStateGb) }}</span>
                        <span v-else class="gray">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',list.intvPropStateGb) }}</span>
                      </td>
                      <td>
                        <span v-if="list.intvPropStateGb === '01'">
                          <KSATextButton class="clickable black_button" text="제안취소" @click="onClickIntvPropState(list.resumeId, list.jobNoticeSeq, '04')"/>
                        </span>
                        <span v-else-if="list.intvPropStateGb === '02'">
                          <KSATextButton class="clickable black_button" text="최종합격" @click="onClickIntvPropState(list.resumeId, list.jobNoticeSeq, '05')"/><br/>
                          <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickIntvPropState(list.resumeId, list.jobNoticeSeq, '06')"/>
                        </span>
                        <span v-else-if="list.intvPropStateGb === '05'">
                          <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickIntvPropState(list.resumeId, list.jobNoticeSeq, '06')"/>
                        </span>
                        <span v-else-if="list.intvPropStateGb === '06'">
                          <KSATextButton class="clickable black_button" text="최종합격" @click="onClickIntvPropState(list.resumeId, list.jobNoticeSeq, '05')"/>
                        </span>
                        <span v-else>
                          -
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="result-none lecture-none" v-if="interviewProposaList.length === 0">
                  등록된 면접제안이 없습니다.
                </div>
                <Paginate
                    v-if="interviewProposaList.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
              </div>
              <!-- e : 면접제안 인재 -->
            </div>
            <div class="lecture-detail" v-show="viewMode !== JOB_FAIR">
              <!-- S : 기업정보 관리 수정 -->
              <div class="table-form" v-if="viewMode === CORP_UPDATE">
                <!-- s : 기업 기본 정보 -->
                <div class="table-form mt-sm">
                  <table class="vertical align-left">
                    <colgroup>
                      <col width="20%" />
                      <col />
                    </colgroup>
                    <tr>
                      <th colspan="2">기업 기본 정보</th>
                    </tr>
                    <tr>
                      <th class="mark">사업자등록번호</th>
                      <td>
                        <KSAInput class="text-box" @input="formatBizNum" v-model="corpUpdate.bizNum" maxLength="15" placeholder="10자리 숫자 입력" />
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.bizNum }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">기업명</th>
                      <td>
                        <KSAInput class="text-box" @input="validateText('corpName')" v-model="corpUpdate.corpName" maxLength="500" />
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.corpName }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">대표자명</th>
                      <td>
                        <KSAInput class="text-box" @input="validateText('ceoName')" v-model="corpUpdate.ceoName" maxLength="50" placeholder="대표명을 입력하세요." />
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.ceoName }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">사업장소재지</th>
                      <td>
                        <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.residenceArea }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">업종</th>
                      <td>
                        <KSAInput class="text-box" v-model="corpUpdate.bizType" @input="validateText('bizType')" maxLength="100" placeholder="업종을 입력하세요." />
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.bizType }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">산업군</th>
                      <td>
                        <template v-for="option in $gb.INDUSTRY_GB">
                          <KSARadioButton class="check-box mr-md" name="industryGb" :label="option.label" v-model="corpUpdate.industryGb" :value="option.value" @change="resetIndustryText(option.value)" />
                          <div class="etc-box" v-if="option.label === '기타' && corpUpdate.industryGb == option.value" >
                            <KSAInput class="text-box" v-model="corpUpdate.industryText" placeholder="기타 산업군을 입력하세요." />
                          </div>
                        </template>
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.industryGb }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">기업형태</th>
                      <td>
                        <template v-for="option in $gb.CORP_GB">
                          <KSARadioButton class="check-box mr-sm" name="corpGb" :label="option.label" v-model="corpUpdate.corpGb" :value="option.value" @change="resetCorpText(option.value)"/>
                          <div class="etc-box" v-if="option.label === '기타' && corpUpdate.corpGb == option.value" >
                            <KSAInput class="text-box" v-model="corpUpdate.corpText" placeholder="기타 기업형태를 입력하세요." />
                          </div>
                        </template>
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.corpGb }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">창립연월</th>
                      <td>
                        <KSAInputDateYYYYMM class="text-box" v-model="corpUpdate.foundYm" @input="validateText('foundYm')" placeholder="YYYY.MM" format="YYYYMM" max-length="5" />
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.foundYm }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">사원수</th>
                      <td>
                        <KSASelect class="select" v-model="corpUpdate.employeeNumGb" :options="[{label: '선택', value: '00'}, ...$gb.EMPLOYEE_NUM_GB]"/>
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.employeeNumGb }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">매출액</th>
                      <td>
                        <KSASelect class="select" v-model="corpUpdate.salesAmtGb" :options="[{label: '선택', value: '00'}, ...$gb.SALES_AMT_GB]"/>
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.salesAmtGb }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark" rowspan="2">상장여부</th>
                      <td>
                        <KSARadioButton class="check-box mr-lg" label="상장" v-model="corpUpdate.corpPublicYn" value="Y" @change="resetCorpPublic('Y')" />
                        <KSARadioButton class="check-box mr-lg" label="비상장" v-model="corpUpdate.corpPublicYn" value="N" @change="resetCorpPublic('N')" />
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.corpPublicYn }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td v-if="corpUpdate.corpPublicYn === 'Y'">
                        <template v-for="option in $gb.CORP_PUBLIC_GB">
                          <KSARadioButton class="check-box mr-sm" name="corpPublicGb" :label="option.label" v-model="corpUpdate.corpPublicGb" :value="option.value" @change="resetCorpPublicText(option.value)" />
                          <div class="etc-box" v-if="option.label === '기타' && corpUpdate.corpPublicGb == option.value" >
                            <KSAInput class="text-box" v-model="corpUpdate.corpPublicText" placeholder="기타 상장을 입력하세요." />
                          </div>
                        </template>
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.corpPublicGb }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>홈페이지 URL</th>
                      <td>
                        <KSAInput class="text-box" v-model="corpUpdate.homeUrl" @input="validateText('homeUrl')" maxLength="200" placeholder="홈페이지 URL을 입력하세요." />
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.homeUrl }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">로고이미지(CI)</th>
                      <td class="text-box">
                        <div class="grid file">
                          <KSAPrimaryButton text="파일 선택" @click="uploadFileCiImg(corpUpdate)" />
                          <KSAInput class="input icon" v-model="corpUpdate.ciImgName" placeholder="파일 선택(1200px X 265px, 300DPI 이미지를 권장합니다.)" disabled />
                          <button class="delete" @click="removeFileCiImg(corpUpdate)"><i></i></button>
                        </div>
                        <small>최대 200MB 까지 첨부 가능</small>
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.ciImg }}</small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">사업자등록증</th>
                      <td class="text-box">
                        <div class="grid file">
                          <KSAPrimaryButton text="파일 선택" @click="uploadFileBizLicense(corpUpdate)" />
                          <KSAInput class="input icon" v-model="corpUpdate.bizLicenseName" placeholder="파일 선택" disabled />
                          <button class="delete" @click="removeFileBizLicense(corpUpdate)"><i></i></button>
                        </div>
                        <small>최대 200MB 까지 첨부 가능</small>
                        <div>
                          <small style="color:#E71414;">{{ errorInputCorp.bizLicense }}</small>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <!-- e : 기업 기본 정보 -->
                <!-- s : 기업 추가 정보 -->
                <div class="table-form mt-sm">
                  <table class="vertical align-left">
                    <colgroup>
                      <col width="20%" />
                      <col />
                    </colgroup>
                    <tr>
                      <th colspan="2">기업 추가 정보</th>
                    </tr>
                    <tr>
                      <th>기업 소개</th>
                      <td>
                        <KSACKEditor ref="editorRef" v-model="corpUpdate.corpIntro" />
                      </td>
                    </tr>
                    <tr>
                      <th>주요 연혁</th>
                      <td>
                        <KSACKEditor ref="editorRef" v-model="corpUpdate.corpHistory" @update:modelValue="validateText('corpHistory')" />
                        <!-- <div> -->
                          <!-- <small style="color:#E71414;">{{ errorInputCorp.corpHistory }}</small>
                        </div> -->
                      </td>
                    </tr>
                    <tr>
                      <th>기업 소개서</th>
                      <td class="text-box">
                        <div class="grid file">
                          <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpIntro(corpUpdate)" />
                          <KSAInput class="input icon" v-model="corpUpdate.corpIntroName" placeholder="파일 선택" disabled />
                          <button class="delete" @click="removeFileCorpIntro(corpUpdate)"><i></i></button>
                        </div>
                        <small>최대 200MB 까지 첨부 가능</small>
                      </td>
                    </tr>
                  </table>
                </div>
                <!-- e : 기업 추가 정보 -->
                <div class="btn-wrap space-between">
                  <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel" />
                  <KSASecondaryButton text="수정 완료" @click="updateCorporation" />
                </div>
              </div>
              <!-- E : 기업정보 관리 수정 -->
              <!-- S : 참가신청 정보 관리 수정 -->
              <div class="table-form" v-if="viewMode === RECRUITMENT_HALL">
                <div class="state-box">
                  현재 참가 신청 상태 : <span>{{ $gbNameKR('USER_JOIN_STATE_GB', jobDetail.joinStateGb) }}</span>
                </div>
                <!-- s : 참가 신청 정보 -->
                <div class="table-form">
                  <table class="vertical align-left">
                    <colgroup>
                      <col width="20%" />
                      <col />
                    </colgroup>
                    <tr>
                      <th colspan="2">참가 신청 정보</th>
                    </tr>
                    <!-- ella : 참가 목적 숨김 요청 (20250904) -->
<!--                    <tr>-->
<!--                      <th class="mark">참가 목적</th>-->
<!--                      <td>-->
<!--                        <KSAInput v-model="recruDetail.joinPurpose" @input="(event) => onInputChange(event, 'joinPurpose')" placeholder="ex) 취업 기회 탐색, 채용  정보 획득, 기업의 인사 담당자 또는 채용 관계자와의 네트워킹 등" />-->
<!--                        <p>-->
<!--                          <small style="color:#E71414;">{{ errorInputRecru.joinPurpose }}</small>-->
<!--                        </p>-->
<!--                      </td>-->
<!--                    </tr>-->
                    <tr>
                      <th rowspan="2">
                        <span class="mark">면접 가능일</span>
                      </th>
                      <td>
                        <ul class="grid category-wrap">
                          <li :class="{'active': isAllActive}" @click="onClickAll(false)">전체 일정 가능</li>
                          <li :class="{'active': day.on, 'disabled': isAllActive}" v-for="day in intvDays" @click="onClickIntvDay(day)">
                            {{ day.label }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul class="grid category-wrap">
                          <li :class="{'active': isEtcActive}" @click="onClickEtc(false)">면접 일정 조율</li>
                        </ul>
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.intvAbleDay }}</small>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">면접 방식</th>
                      <td>
                        <template v-for="option in $gb.INTV_GB">
                          <KSARadioButton class="check-box mr-lg" name="intvGb" :label="option.label" v-model="recruDetail.intvGb" :value="option.value" @change="optionData('intvGb')"/>
                        </template>
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.intvGb }}</small>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">이력서 양식</th>
                      <td>
                        <p class="red mb-xs" v-if="recruDetail.fileYn === 'Y'">※ ‘협회 이력서‘ 양식 사용을 권장합니다.</p>
                        <KSARadioButton class="check-box mr-lg" label="협회 이력서" v-model="recruDetail.fileYn" value="N" @change="resetFile('N')" />
                        <KSARadioButton class="check-box mr-lg" label="회사 이력서" v-model="recruDetail.fileYn" value="Y" @change="resetFile('Y')" />
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.fileYn }}</small>
                        </p>
                      </td>
                    </tr>
                    <tr v-if="recruDetail.fileYn === 'Y'">
                      <th class="mark">회사 이력서 양식 첨부</th>
                      <td class="text-box">
                        <div class="mb-xs">
                          <p class="red">* 첨부 전 반드시 확인해주세요!</p>
                          - 의도치 않게 개인정보가 노출될 수 있으므로 첨부하는 파일에 <span class="red">실제 개인정보가 입력되어 있는지 확인</span>해주세요.<br>
                          - 첨부된 파일로 인해 개인정보가 노출될 경우 책임은 첨부한 기업에 있음을 알려드립니다.<br>
                          - 파일명은 <span class="red">‘기업명_이력서양식‘</span> 으로 첨부해 주세요.
                        </div>
                        <div class="grid file" v-for="(attach, index) in recruDetail.corpResumeAttaches" :key="index">
                          <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpResume(attach)" />
                          <KSAInput class="input icon" v-model="attach.fileName" placeholder="파일 선택" disabled />
                          <button class="delete" @click="removeFileCorpResume(recruDetail, index)"><i></i></button>
                        </div>
                        <small>최대 200MB 까지 첨부 가능</small>
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.corpResumeAttaches }}</small>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">모집인원</th>
                      <td>
                        <div class="grid half">
                          <KSAInputNumber v-model="recruDetail.recruitCnt" @input="validateText('recruitCnt')" placeholder="0" maxLength="2" /> 명
                        </div>
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.recruitCnt }}</small>
                        </p>
                      </td>
                    </tr>
                  </table>
                </div>
                <!-- e : 참가 신청 정보 -->
                <!-- s : 참가 신청 담당자 정보 -->
                <div class="table-form mt-sm">
                  <table class="vertical align-left">
                    <colgroup>
                      <col width="20%" />
                      <col />
                    </colgroup>
                    <tr>
                      <th colspan="2">참가 신청 담당자 정보</th>
                    </tr>
                    <tr>
                      <th class="mark">성명</th>
                      <td>
                        <KSAInput class="text-box" v-model="recruDetail.chargeName" @input="validateText('chargeName')" maxLength="10" placeholder="성명을 입력하세요." />
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.chargeName }}</small>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">부서</th>
                      <td>
                        <KSAInput class="text-box" v-model="recruDetail.chargeDepart" @input="validateText('chargeDepart')" maxLength="10" placeholder="부서를 입력하세요." />
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.chargeDepart }}</small>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">직위</th>
                      <td>
                        <KSAInput class="text-box" v-model="recruDetail.chargeJob" @input="validateText('chargeJob')" maxLength="10" placeholder="직위를 입력하세요." />
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.chargeJob }}</small>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">회사 직통번호</th>
                      <td>
                        <!-- 20250924(ella): 회사 직통번호 밸리데이션 제거 -->
<!--                        <KSAInputGeneralPhoneNum class="text-box" label="" v-model="recruDetail.chargeCompanyNum" @input="validateText('chargeCompanyNum')" placeholder="회사 직통번호를 입력하세요." />-->
                        <KSAInput class="text-box" v-model="recruDetail.chargeCompanyNum" @input="validateText('chargeCompanyNum')" maxLength="200" placeholder="회사 직통번호를 입력하세요. ex) 02-1234-5678" />
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.chargeCompanyNum }}</small>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">휴대전화</th>
                      <td>
                        <KSAInputPhoneNum class="input" v-model="recruDetail.chargePhoneNum" label="" @input="validateText('chargePhoneNum')" maxLength="200" placeholder="휴대폰 번호를 입력하세요."/>
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.chargePhoneNum }}</small>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="mark">이메일</th>
                      <td>
                        <KSAInput class="text-box" v-model="recruDetail.chargeEmail" @input="validateText('chargeEmail')" maxLength="50" placeholder="이메일 주소를 입력하세요." />
                        <p>
                          <small style="color:#E71414;">{{ errorInputRecru.chargeEmail }}</small>
                        </p>
                      </td>
                    </tr>
                  </table>
                </div>
                <!-- e : 참가 신청 담당자 정보 -->
                <div class="btn-wrap space-between">
                  <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel" />
                  <KSASecondaryButton text="수정 완료" @click="updateRecruitmentHall" />
                </div>
              </div>
              <!-- E : 참가신청 정보 관리 수정 -->
              <!-- S : 입사지원 목록 -->
              <div class="table-form" v-if="viewMode === RETRIEVE_APPLICANT">
                <div v-if="viewMode === RETRIEVE_APPLICANT">
                  <div class="list-top mb-n-xs">
                    <KSASecondaryButton text="이전" @click="setViewMode(JOB_FAIR)" />
                  </div>
                  <div class="list-top">
                    <p>총 <span>{{ $number(totalCountDepth2)}}</span>명</p>
                    <div>
                      <KSAPrimaryButton v-if="applicantList.length > 0" text="이력서 다운로드" @click="onClickExcelDownload(detailCommonId)" />
                      <KSAPrimaryButton text="채용공고 보기" @click="onClickJobNotice(detailCommonId)" class="ml-xs" />
                    </div>
                  </div>
                  <div class="table-form">
                    <table class="table-form board-mobile-vertical" v-if="applicantList !== null">
                      <tr>
                        <th>번호</th>
                        <th>이름</th>
                        <th>이력서 제목</th>
                        <th v-if="jobDetail.fileYn === 'N'">관심 카테고리</th>
                        <th>면접 가능일</th>
                        <th>입사 지원일</th>
                        <th>상태</th>
                        <th>상태변경</th>
                      </tr>
                      <tr v-for="list in applicantList">
                        <td>{{ list.boardNo }}</td>
                        <td>{{ list.userName }}</td>
                        <td>
                          <p class="file text-overflow long-overflow" v-if="list.fileYn === 'Y'" v-for="resumeAttaches in list.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                            {{ resumeAttaches.fileName }}
                          </p>
                          <p class="clickable blue text-overflow long-overflow" v-else @click="onClickMyResume(list.resumeId, jobDetail.ojfId)">
                            {{ list.title }}
                          </p>
                        </td>
                        <td v-if="jobDetail.fileYn === 'N'">{{ list.interests }}</td>
                        <td class="word-break-all">
                          <span v-if="list.intvInYn === 'Y' && isAllSelected2">
                            전체 일정 가능
                            [{{ list.intvAbleDay }}]
                          </span>
                          <span v-if="list.intvInYn === 'Y'">
                            {{ list.intvAbleDay }}
                          </span>
                          <span v-else>면접 일정 조율</span>
                        </td>
                        <td>{{ $yyyymmddHHmmss(list.createDate) }}</td>
                        <td>
                          <span v-if="list.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
                          <span v-else-if="list.applyStateGb === '03' ||  list.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
                          <span v-else-if="list.applyStateGb === '04' || list.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
                          <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
                        </td>
                        <td>
                          <div v-if="list.applyStateGb === '01'">
                            <KSATextButton class="clickable mr-xs black_button" text="서류합격" @click="onClickApplyStateGb(list.resumeId, list.jobNoticeSeq, '03')"/><br/>
                            <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(list.resumeId, list.jobNoticeSeq, '04')"/>
                          </div>
                          <div v-else-if="list.applyStateGb === '03'">
                            <KSATextButton class="clickable mr-xs black_button" text="최종합격" @click="onClickApplyStateGb(list.resumeId, list.jobNoticeSeq, '05')"/><br/>
                            <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(list.resumeId, list.jobNoticeSeq, '06')"/>
                          </div>
                          <div v-else>
                            -
                          </div>
                        </td>
                      </tr>
                      <tr v-if="applicantList.length === 0">
                        <td colspan="9">입사 지원 내역이 없습니다.</td>
                      </tr>
                    </table>
                    <Paginate
                        v-if="applicantList.length > 0"
                        v-model="currentPageDepth2"
                        :page-count="totalPagesDepth2"
                        :click-handler="() => onSelectPage(currentPageDepth2, 2)"
                    />
                  </div>
                </div>
              </div>
              <!-- E : 입사지원 목록 -->
            </div>
          </div>
        </div>
        <!-- E : 강의 상세-->
      </div>
    </div>
  </div>
  <JobFairResumeOpenModal ref="jobFairResumeOpenModal" :showButtons="false"/> <!-- 텍스트 색상을 위한 디자인 팝업 -->
  <LecturePlayerModal ref="lecturePlayerModal"/>
  <LectureResumeModal ref="lectureResumeModal" :showButtons="false"/>
  <LectureSurveyModal ref="lectureSurveyModal" />
  <JobFairResumeModal ref="jobFairResumeModal"/> <!-- 특별채용관 이력서 상세 -->
  <JobFairJobNoticeModal ref="jobNoticeModal"/> <!-- 채용공고 상세 -->
  <JobFairJobNoticeListModal ref="jobNoticeListModal" /> <!-- 채용공고 목록 -->

</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.file {
  color: $blue_color;
  cursor: pointer;
}

.etc-box {
  display: inline-block;
  width: 200px;
}

.category-wrap {
  .disabled {
    background: $gray-light_color;
    cursor: default;
  }
}

.instructions {
  background: $gray-regular_color;
  padding: 20px;
  p {
    &:before {
      content: "ㆍ";
    }
    .red {
      display: inline-block;
      color: $red_color;
    }
  }
}

.state-box {
  border: 2px solid $black_color;
  border-bottom: 0;
  padding: 10px 20px;
  span {
    color: $blue_color;
  }
}
.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          span {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
            &.mark {
              font-size: $font-size_sm;
              color: $black_color;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
}
.board-detail {
  .header {
    border-top: 0;
  }
  .table-form {
    table {
      border-top: 0;
    }
  }
}
</style>